import { AnySchema } from 'yup';
import { Control } from 'react-hook-form';
import countryData from '@data/countries.json';

import { HSMSSelect } from './HSMSSelect';

interface HSMSCountrySelectProps {
  label: string;
  name: string;
  disabled?: boolean;
  validationSchema?: AnySchema;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any; // If we are setting proper types we need to get the form values. Not possible since we use this in multiple forms
}

export const HSMSCountrySelect = ({
  label,
  name,
  validationSchema,
  disabled,
  control,
  errors,
}: HSMSCountrySelectProps) => (
  <HSMSSelect
    disabled={disabled}
    label={label}
    name={name}
    options={countryData}
    validationSchema={validationSchema}
    control={control}
    errors={errors}
  />
);
